import { Form, Input, Modal, Spin, message } from "antd";
import React, { useState } from "react";
import { generateFormRules } from "../../../../helpers/formRules";
import { getMainEmailAddress } from "../../../../helpers/profile";
import useAuth from "../../../../hooks/useAuth";
import { httpRequest } from "../../../../helpers/api";
import { getErrorMessage } from "../../../../helpers/errorHandler";

interface FormValues {
	comment: string;
}

interface IProps {
	open: boolean;
	type: string;
	onClose?: () => void;
	// setIsFetch?: React.Dispatch<React.SetStateAction<boolean>>;
	articleId: string;
	commentId?: string;
	onSuccess?: () => void;
}
export default function ModalAddCommentOrReply(props: IProps) {
	const { user } = useAuth();
	const [form] = Form.useForm();
	const [isActionLoading, setIsActionLoading] = useState(false);

	const doSubmit = async (values: FormValues) => {
		setIsActionLoading(true);

		try {
			if (props.type === "comment") {
				const dto = {
					articleId: props.articleId,
					email: getMainEmailAddress(user?.profile!),
					comment: values?.comment,
					name: user.nickName,
					createdByUserId: user.userId,
					metaCreatedByUser: user,
				};

				await httpRequest.post("/article-comments", dto);
			} else if (props.type === "reply") {
				const dto = {
					commentId: props.commentId,
					comment: values?.comment,
					name: user.nickName,
					email: getMainEmailAddress(user?.profile!),
					createdByUserId: user.userId,
					metaCreatedByUser: user,
				};

				await httpRequest.post("/article-reply-comments", dto);
			}

			props.onSuccess?.();
			props.onClose?.();
			reset();
		} catch (error) {
			message.error(getErrorMessage(error));
		}
		setIsActionLoading(false);
	};

	const reset = () => {
		form.resetFields();
		setIsActionLoading(false);
	};

	return (
		<Modal
			destroyOnClose={true}
			title={`Add ${props.type === "reply" ? "Reply" : "Comment"}`}
			open={props.open}
			onCancel={() => {
				props.onClose?.();
				reset();
			}}
			onOk={form.submit}
			okText={"Add"}
			okButtonProps={{
				loading: isActionLoading,
			}}
			width={520}
		>
			<Spin spinning={isActionLoading}>
				<Form
					form={form}
					preserve={false}
					layout="vertical"
					name="basic"
					autoComplete="off"
					onFinish={doSubmit}
				>
					<Form.Item
						name="comment"
						label={props.type === "comment" ? "Comment" : "Reply"}
						rules={generateFormRules(props.type === "comment" ? "Comment" : "Reply", ["required"])}
					>
						<Input.TextArea
							rows={3}
							placeholder={`Enter a ${props.type === "comment" ? "comment" : "reply"}`}
						/>
					</Form.Item>
				</Form>
			</Spin>
		</Modal>
	);
}
